import { IconWrapper } from '../runtime';
export default IconWrapper('space', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M2.00036 4.49978L5.50036 6.49978M14.0004 4.49978L10.5004 6.49978M8.00036 13.9998V10.9998M1.72168 5.08721V10.9123C1.72168 11.275 1.91802 11.6092 2.23478 11.7858L7.51346 14.7284C7.81614 14.8971 8.18459 14.8971 8.48727 14.7284L13.766 11.7858C14.0827 11.6092 14.279 11.275 14.279 10.9123V5.08721C14.279 4.72456 14.0827 4.39033 13.7659 4.21375L8.48727 1.2712C8.18459 1.10247 7.81614 1.10247 7.51346 1.2712L2.23478 4.21375C1.91802 4.39033 1.72168 4.72456 1.72168 5.08721ZM5.40229 6.78845V9.2111C5.40229 9.38973 5.49759 9.5548 5.65229 9.64411L7.75036 10.8554C7.90506 10.9448 8.09566 10.9448 8.25036 10.8554L10.3484 9.64411C10.5031 9.5548 10.5984 9.38974 10.5984 9.2111V6.78845C10.5984 6.60982 10.5031 6.44476 10.3484 6.35544L8.25036 5.14411C8.09566 5.0548 7.90506 5.0548 7.75036 5.14411L5.65229 6.35544C5.49759 6.44476 5.40229 6.60982 5.40229 6.78845Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});